import './sectionBodyGrid.scss';

interface ISectionBodyGridProps {
    children: JSX.Element;
    displayBlock?: boolean;
}

const SectionBodyGrid: React.FC<ISectionBodyGridProps> = ({ children, displayBlock = false }) => {
    return <div className={displayBlock ? 'sectionBodyGrid_block' : 'sectionBodyGrid_grid'}>{children}</div>;
};

export default SectionBodyGrid;
